<script setup lang="ts"></script>

<template>
  <Contacts1Title />
  <Contacts2Links />
</template>
